/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    IAccountProfileItem,
    IAccountProfileViewProps
} from '@msdyn365-commerce-modules/account-management/dist/types/modules/account-profile/account-profile';

const AccountProfileSection: React.FC<IAccountProfileItem> = ({ AccountProfileItem, heading, links, description }) => {
    return (
        <Node {...AccountProfileItem}>
            {heading}
            {description}
            {links}
        </Node>
    );
};

const AccountProfileView: React.FC<IAccountProfileViewProps> = props => {
    const { AccountProfile, heading, emailSection, nameSection } = props;
    const { data } = props;
    const customerInformation = data.customerInformation.result;
    const firstName = (customerInformation && customerInformation.FirstName) || undefined;
    const lastName = (customerInformation && customerInformation.LastName) || undefined;
    const email = (customerInformation && customerInformation.Email) || undefined;

    return (
        <Module {...AccountProfile}>
            {heading}
            {email && <AccountProfileSection {...emailSection} />}
            {firstName && lastName && <AccountProfileSection {...nameSection} />}
        </Module>
    );
};

export default AccountProfileView;
